export default "__VITE_ASSET__DYvsmB0n__"